import { Severity } from '../../../../../common/enums/Severity';
import { ReferenceLink } from '../../../../../common/models/ReferenceLink';

export class Issue {
  constructor(
    private readonly number: number,
    private readonly title: string,
    private readonly severity: Severity,
    private readonly shortExplanation: string | null,
    private readonly explanation: string | null,
    private readonly consequences: string | null,
    private readonly access: string | null,
    private readonly expertise: string | null,
    private readonly resources: string | null,
    private readonly links: ReferenceLink[]
  ) {}

  getNumber() {
    return this.number;
  }

  getTitle() {
    return this.title;
  }

  getSeverity() {
    return this.severity;
  }

  getExplanation() {
    return this.explanation;
  }

  getShortExplanation() {
    return this.shortExplanation;
  }

  getConsequences() {
    return this.consequences;
  }

  getAccess() {
    return this.access;
  }

  getExpertise() {
    return this.expertise;
  }

  getResources() {
    return this.resources;
  }

  getLinks() {
    return this.links;
  }
}
